module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/id/2-788c3c0980351587ed23be60cb826426.jpg";